/* eslint-disable react/forbid-prop-types */
/* eslint-disable global-require, no-case-declarations */
import { string, bool, array } from 'prop-types';
import React from 'react';
import { backgroundVariantOptions } from 'TMPropTypes/commonOptionsProps';
import dictionary from './dictionary';
import SharedOptions from './SharedOptions';
import parseCommonOptions from './parseCommonOptions';

const ComponentMapper = ({
    __typename,
    hideOnMobile,
    hideOnDesktop,
    /** @deprecated use @commonOptions instead */
    backgroundVariant,
    whiteBackground,
    isPageContent,
    commonOptions,
    ...item
}) => {
    const Component = dictionary[__typename];
    if (!Component) return <p>{__typename}</p>;

    const common = parseCommonOptions(commonOptions);

    // whilst backgroundVariant is being phased out
    const background = common?.backgroundVariant || backgroundVariant;

    return (
        <SharedOptions
            backgroundVariant={isPageContent ? background : 'none'}
            whiteBackground={whiteBackground}
            hideOnMobile={common?.hideOnMobile || hideOnMobile}
            hideOnDesktop={common?.hideOnDesktop || hideOnDesktop}
            noSideMargins={
                background || item.imageCover || whiteBackground
            }>
            <Component
                backgroundVariant={background}
                listTickVariant={common?.listTickVariant}
                noUnderline={common?.noUnderline}
                {...item}
                commonOptions={common}
            />
        </SharedOptions>
    );
};

ComponentMapper.propTypes = {
    __typename: string.isRequired,
    hideOnMobile: bool,
    hideOnDesktop: bool,
    backgroundVariant: backgroundVariantOptions,
    whiteBackground: bool,
    isPageContent: bool,
    commonOptions: array // this is different shape from other mentions as this comes from dato before it gets parsed to an object
};

export default ComponentMapper;
